import { render, staticRenderFns } from "./CBSPoa.vue?vue&type=template&id=3ce99264&"
import script from "./CBSPoa.vue?vue&type=script&lang=js&"
export * from "./CBSPoa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports